<template>
  <pt-task-lot-operate class="pt-task-lot-operate__withData"></pt-task-lot-operate>
</template>

<script>
import PtTaskLotOperate from './index'
export default {
  name: 'pt-task-lot-operate__withData',
  components: {
    'pt-task-lot-operate': PtTaskLotOperate
  }
}
</script>
